<div class="banner" *ngIf="backNavigationAllowed()">
  <button type="button" class="back-button" (click)="reroute()">
    <app-zaver-icon [size]="14" name="chevronLeft"></app-zaver-icon>
  </button>
</div>
<app-de-wrapper>
  <app-zaver-icon class="bankid-logo" name="bankIDse" [size]="92"></app-zaver-icon>

  <ng-container *ngIf="showQrCode && !bankidAuthFailed">
    <div class="heading">Vänligen öppna din BankID-app för att fortsätta</div>

    <div class="qr-container">
      <div class="qr" #canvas></div>
    </div>

    <span class="status-message"> {{ bankIdStatusMessage }} </span>

    <a class="second-option-link" (click)="autoStartAppClick()">
      <u>Öppna från denna enhet istället</u>
    </a>
  </ng-container>

  <ng-container *ngIf="!showQrCode && !bankidAuthFailed">
    <span *ngIf="authInProgress" class="status-message">
      {{ bankIdStatusMessage }}
    </span>

    <div *ngIf="authInProgress && !showQrCode">
      <zaver-loading-dots
        *ngIf="autoStart"
        [color]="'#b7bcc8'"
      ></zaver-loading-dots>
      <zaver-primary-button
        *ngIf="!autoStart"
        text="Öppna BankId"
        [disabled]="isStartBankIdButtonEnabled()"
        [logo]="'assets/icon/BankID-Vector-Logo-White.svg'"
        (click)="openBankIdApp()"
      ></zaver-primary-button>
    </div>

    <a class="second-option-link" (click)="showQrCodeClick()">
      <u>Öppna från en annan enhet</u>
    </a>
  </ng-container>

  <ng-container *ngIf="bankidAuthFailed">
    <zaver-alert-box
      style="margin-bottom: 28px"
      type="WARNING"
      [messageList]="['Legitimering misslyckades.', 'Vänligen försök igen.']"
    ></zaver-alert-box>

    <zaver-primary-button
      [text]="'Försök igen'"
      (click)="showQrCodeClick()"
      [logo]="'assets/icon/BankID-Vector-Logo-White.svg'"
    ></zaver-primary-button>

    <a class="second-option-link" (click)="autoStartAppClick()">
      <u>Öppna från denna enhet istället</u>
    </a>
  </ng-container>
</app-de-wrapper>